export default __webpack_public_path__ + "static/1571-1295c605561ecd91d3fff874a7d985c1.gif";